// src/ui/SectionMenuLayer.jsx
import React from "react";
import "./SectionMenuLayer.css";


export function SectionMenuLayer({ section, onClose, onSelectPage }) {
  const COLORS = {
    "01": "rgba(250, 148, 2, 0.5)", // Account
    "02": "rgba(48, 199, 40, 0.5)", // General
    "03": "rgba(22, 128, 217, 0.5)", // Map
    "04": "rgba(196, 18, 18, 0.5)", // Offense
    "05": "rgba(143, 136, 33, 0.5)", // Defence
  };

  const accent = COLORS[section] || "#214072";


  // Konfiguration: welche Items pro Section?
const MENU_ITEMS = {
  "01": [
    { id: "acc-account",       title: "Mein LegendsTools",     subtitle: "Benutzeraccount verwalten" },
    { id: "acc-docs",          title: "Dokumentation",         subtitle: "Anleitungen & Hilfen" },
    { id: "acc-pricing",       title: "Preise / Abonnements",  subtitle: "Pakete & Konditionen" },
    { id: "acc-changelog",     title: "Changelog",             subtitle: "Änderungen & Updates" },
    { id: "acc-about",         title: "Über uns",              subtitle: "Team & Hintergrund" },
    { id: "acc-support",       title: "Support / Kontakt",     subtitle: "Fragen & Hilfe" },
  ],
  "02": [
    { id: "tools-buildings",   title: "Gebäuderechner",        subtitle: "Ausbaukosten & Zeiten" },
    { id: "tools-resources",   title: "Ressourcenausbau",      subtitle: "Minen, Felder, Effizienz" },
    { id: "tools-oases",       title: "Oasentool",             subtitle: "Boni & Belegungen" },
    { id: "tools-culture",     title: "Kulturpunkterechner",   subtitle: "KP-Planung" },
    { id: "tools-research",    title: "Forschungsrechner",     subtitle: "Schmiede & Akademie" },
    { id: "tools-paths",       title: "Wegerechner",           subtitle: "Laufzeiten & Entfernungen" },
    { id: "off-hero",          title: "Heldenrechner",         subtitle: "Attribute & Boni" },
    { id: "off-troops",        title: "Truppenwerte",          subtitle: "Einheiten im Überblick" },
  ],
  "03": [
    // LT MAP 3.0 → später externe App-Link, erst mal nur Platzhalter
    { id: "map-main",          title: "LT MAP 3.0",            subtitle: "Kartenansicht & Marker" },
    { id: "map-servers",       title: "Travian Serverliste",   subtitle: "Welten & Laufzeiten" },
    { id: "map-players",       title: "Spieler",               subtitle: "Stats & Profile" },
    { id: "map-alliances",     title: "Allianzen",             subtitle: "Ranglisten & Details" },
  ],
  "04": [
    { id: "off-ep",            title: "Einsatzplaner",         subtitle: "Aktionen planen (extern)" },
    { id: "off-inactive",      title: "Inaktivensuche",        subtitle: "Farm-Ziele finden" },
    { id: "off-kata",          title: "Katapultrechner",       subtitle: "Ziel-Level & Treffer" },
    { id: "off-reportparser",  title: "Kampfberichtparser",    subtitle: "Berichte auswerten" },
    { id: "off-artefacts",     title: "Artefakte",             subtitle: "Effekte & Besitz" },
    { id: "off-sim",           title: "Kampfsimulator",        subtitle: "Schlachten testen" },
    { id: "off-offcalc",       title: "Off-Rechner",           subtitle: "Offensivkraft" },
    { id: "off-defcalc",       title: "Deff-Rechner",          subtitle: "Defensivwert" },
   
    
    { id: "off-intercept",     title: "Abfangrechner",         subtitle: "Abfangfenster planen" },
    { id: "off-merge",         title: "Merge-Rechner",         subtitle: "Truppenzusammenlegung" },
  ],
  "05": [
    { id: "ally-my",           title: "Meine Allianz(en)",     subtitle: "Mitgliedschaften & Rollen" },
    { id: "ally-tool",         title: "Truppentool",           subtitle: "Allianz gründen / verwalten" },
  ],
};







  return (
    <div
      style={{
        position: "absolute",
        left: 240,          // 250 LeftRail + 4 Gap
        top: 240,
        width: 280,
        zIndex: 50,
        pointerEvents: "auto",
        // für CSS-Hover (farbiger Rahmen)
        "--accent": accent,
      }}
    >
      <div
        className="sectionlayer-panel"
        style={{
          borderRadius: 4,
          boxShadow: "0 3px 10px rgba(0,0,0,.9)",
          overflow: "hidden",
          background: "rgba(5,20,25,0.9)",
        }}
      >
        {/* Header-Bar */}
        <header
          style={{
            background: accent,
            padding: "4px 10px",
            fontSize: "var(--fs-12, 12px)",
            letterSpacing: ".12em",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            {section === "01" && "Account | Informationen"}
            {section === "02" && "Tools | General"}
            {section === "03" && "Map | Statistics"}
            {section === "04" && "Offense | Defence"}
            {section === "05" && "Alliance | Meta"}
          </span>
          <button
            type="button"
            onClick={onClose}
            style={{
              all: "unset",
              cursor: "pointer",
              padding: "0 0px",
              fontSize: 24,
              color: "#a22",
            }}
            aria-label="Menü schließen"
          >
            ⭙
          </button>
        </header>

        {/* Body */}
        <div style={{ padding: "10px 12px 12px" }}>
          <p
            style={{
              margin: "0 0 10px",
              width: "92%",
              alignItems: "center",
              gap: 10,
              borderRadius: 5,
              padding: "0px 10px 0px 10px",
              background: "rgba(50,50,50,.55)",
              fontSize: "var(--fs-12, 12px)",
              color: "rgba(255, 255, 255,0.5)",
            }}
          >
            ⓘ Kurzbeschreibung der Sektion. (Text aus Content später
            nachziehen.)
          </p>

          <nav aria-label="Sektion-Links">
            <ul className="ll-list">
            {(MENU_ITEMS[section] || []).map(item => (
      <MenuItem
        key={item.id}
        title={item.title}
        subtitle={item.subtitle}
        onClick={() => onSelectPage?.(item.id)}
      />
    ))}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

function MenuItem({ title, subtitle, onClick }) {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        className="ll-item"
        
      >
        <span
          style={{
            width: 28,
            height: 28,
            borderRadius: 2,
            background: "color-mix(in srgb, var(--accent) 55%, #111 45%)",
            boxShadow:
              "inset 0 1px 0 rgba(255,255,255,.06), inset 0 -1px 0 rgba(0,0,0,.5)",
            flexShrink: 0,
          }}
        />
        <span style={{ display: "flex", flexDirection: "column" }}>
          <b style={{ fontSize: "var(--fs-12, 12px)", color: "rgba(255, 255, 255,0.7)", opacity: 1.0 }}>{title}</b>
          {subtitle && (
            <small
              style={{ fontSize: "var(--fs-12, 12px)", opacity: 0.6 }}
            >
              {subtitle}
            </small>
          )}
        </span>
      </button>
    </li>
  );
}
